<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'drawer-content'

  // const modifiers = {
  //   isOpen: 'is-open'
  // }

  export default {
    name: 'DrawerContent',
    components: {},
    mixins: [ bem ],
    props: {
      // isOpen: {
      //   type: false
      // },
    },
    data: function () {
      return {
        isFirstTime: true
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.handleMounted()
    },
    methods: {
      // classnameModifiers: function () {
      //   const isOpen = this.isOpen && modifiers.isOpen
      //   console.log(isOpen)
      //   return null
      // },
      emitHeight: function () {
        // if (!this.isFirstTime) {
        //   const height = this.getHeight()
        //   this.$emit('hasheight', height)
        // }
        const height = this.getHeight()
        this.$emit('hasheight', height)
      },
      getHeight: function () {
        let height = 0

        if (this.$el) {
          height = this.$el.offsetHeight
        }

        return height
      },
      handleMounted: function () {
        this.emitHeight()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Drawer/DrawerContent.vue